import React from "react";
import "./CWChecBoxLabel.scss";
import { ChecBoxProperty }  from '../interfaces/generalInterface'
import Form from "react-bootstrap/Form";

interface InputCheck extends ChecBoxProperty {
  onChange?: (str: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const InputCheck = (props: InputCheck) => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (props.onChange) props.onChange(e);
  };

  return (
    <div className="form-group">
      <div className="checkbox-group">
        <span className="label d-block">{props.title}</span>
        <div className="mb-4">
        <div className="check-wrap d-flex align-items-center">
          <Form.Check
            id={props.id}
            key={props.id}
            type={props.type}
            name={props.name}
            label={props.label}
            checked={props.checked}
            onChange={onChange}
            value={props.value}
            disabled={props.disabled}
          />
          {props?.image}
        </div>
        {props.errorMessage && props.errorMessage !== "" && <span className="error-msg">{props.errorMessage}</span>}
        </div>
      </div>
    </div>
  );
};

export default InputCheck;
